import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CourseTemplate, PayloadResponse } from '../models';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { ApiService } from '../../shared/services';

@Injectable({
  providedIn: 'root'
})
export class CourseTemplateService {
  private apiService = inject(ApiService);
  constructor(
  ) { }

  getCoursesTemplateList(
    pageNumber?: number,
    pageSize?: number
  ): Observable<PayloadResponse<CourseTemplate[]>> {
    let params = new HttpParams();

    if (pageNumber) params = params.set('pageNumber', pageNumber);
    if (pageSize) params = params.set('pageSize', pageSize);

    return this.apiService.get('course-template', { params: params });
  }

}
